module.exports = __webpack_public_path__ + "img/photo-1.a800b23a.jpg";